import { WatchDialogQueryWithWatchChildren } from './WatchDialogQuery.graphql.js';

export const getWatchDialogQuery = () => {
	return WatchDialogQueryWithWatchChildren;
};
